import {
  StepperFormStepStateType,
  StepperFormStepType,
} from './StepperForm.types';

export const createInitialStepState = (
  steps: StepperFormStepType[],
  activeStepIndex: number,
  isLinear: boolean,
): StepperFormStepStateType[] =>
  steps.map(({ initialValues, required, onValidate }, index) => {
    const isActive = index === activeStepIndex;
    const hasError = !!Object.keys(onValidate(initialValues)).length;
    return {
      hasError,
      isActive,
      isDisabled: !isActive && isLinear,
      isRequired: !!required,
      isValid: !hasError,
      values: initialValues,
    };
  });
